export class SystemConstants {
    public static API_ENDPOINT = 'API_ENDPOINT';
    public static CURRENT_USER = 'CURRENT_USER';
    public static CURRENT_BRANCH = 'CURRENT_BRANCH';
    public static CURRENT_USERID = 'CURRENT_USERID';
    public static CURRENT_USERNAME = 'CURRENT_USERNAME';
    public static MAIL_TOKEN = 'MAIL_TOKEN';
    public static CURRENT_USERFULLNAME = 'CURRENT_USERFULLNAME';
    public static CURRENT_EMPLOYEE = 'CURRENT_EMPLOYEE';
    public static POSITION_EMPLOYEE = 'POSITION_EMPLOYEE';
    public static CURRENT_USERISADMIN= 'CURRENT_USERISADMIN';
    public static CURRENT_ISSYSADMIN = 'CURRENT_ISSYSADMIN';
    public static EXPLORER_PARRENTKEY_VALUE = 'EXPLORER_PARRENTKEY_VALUE';
    public static PERMISSION_DATA = 'PERMISSION_DATA';
    public static ALLOW_DBLCLICK = 'ALLOW_DBLCLICK';
    public static PARAMETER_LINKREPORT = 'PARAMETER_LINKREPORT';
    public static ID_VOUCHER = 'ID_VOUCHER';
    public static LAST_ACTION_AT = 'LAST_ACTION_AT';
    public static MODULE_ALLOW = 'MODULE_ALLOW';
    public static LAYOUT_CURRENT = 'LAYOUT_CURRENT';
    public static PERMISSION_DATA_POSITION = 'PERMISSION_DATA_POSITION';
    public static INFO_LINKCOMMAND = 'INFO_LINKCOMMAND';
    public static ITEM_PARENT_PRE = 'ITEM_PARENT_PRE';
    public static FILTER_DATA = 'FILTER_DATA';
    public static EMPLOYEE_INFO = 'EMPLOYEE_INFO';
    public static CONFIG = 'CONFIG';
    public static SYSTEM_ALL = 'SYSTEM_ALL';
    public static FISCAL_YEAR = 'FISCAL_YEAR';
    public static CURRENT_LANGUAGE = 'CURRENT_LANGUAGE';
    public static WEB_NAME = 'WEB_NAME';
    public static WEB_TITLE = 'WEB_TITLE';
    public static WEB_VERSION = 'WEB_VERSION';
    public static WEB_CONFIG = 'WEB_CONFIG';
    public static CURRENT_LOCATION = 'CURRENT_LOCATION';
}



// WEBPACK FOOTER //
// D:/01.Developer/0.Web/Bravo8-Base/src/app/core/common/system.constants.ts